import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    words: Array,
    interval: { type: Number, default: 1500 }
  }

  connect() {
    this.index = 0
    this.element.style.transition = 'opacity 0.25s ease, transform 0.25s ease'
    this.element.style.textAlign = 'center'

    // Lock width to the widest word so the sentence never reflows
    this.element.style.minWidth = this.#measureMaxWidth()

    this.timer = setInterval(() => this.rotate(), this.intervalValue)
  }

  #measureMaxWidth() {
    const probe = document.createElement('span')
    probe.style.cssText = `
      position: absolute; visibility: hidden; white-space: nowrap;
      font: ${getComputedStyle(this.element).font};
    `
    document.body.appendChild(probe)
    const maxWidth = Math.max(...this.wordsValue.map(word => {
      probe.textContent = word
      return probe.getBoundingClientRect().width
    }))
    document.body.removeChild(probe)
    return `${maxWidth}px`
  }

  disconnect() {
    clearInterval(this.timer)
  }

  rotate() {
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateY(-10px)'

    setTimeout(() => {
      this.index = (this.index + 1) % this.wordsValue.length
      this.element.textContent = this.wordsValue[this.index]
      this.element.style.transform = 'translateY(10px)'
      this.element.style.transition = 'none'

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.element.style.transition = 'opacity 0.25s ease, transform 0.25s ease'
          this.element.style.opacity = '1'
          this.element.style.transform = 'translateY(0)'
        })
      })
    }, 250)
  }
}
